import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Realmente entregan en 5 días?',
  answer: 'Sí. Nuestro método UltraExpress™ combina AI con un equipo experto para entregar resultados en tiempo récord sin sacrificar calidad. Optimizamos cada paso del proceso para ser eficientes.'
}, {
  question: '¿Funciona para mi tipo de negocio?',
  answer: 'Trabajamos con todo tipo de negocios: servicios profesionales, e-commerce, restaurantes, clínicas, bienes raíces y más. Adaptamos el diseño y la estrategia a tu nicho específico.'
}, {
  question: '¿Qué pasa si no me gusta el diseño?',
  answer: 'Incluimos hasta 2 rondas de revisiones para asegurar que el resultado final sea exactamente lo que necesitas. Trabajamos contigo hasta que estés 100% satisfecho.'
}, {
  question: '¿Incluye el dominio y hosting?',
  answer: 'Sí, el primer año de dominio y hosting está incluido en tu inversión. Nosotros nos encargamos de toda la configuración técnica.'
}, {
  question: '¿Cómo es el proceso de pago?',
  answer: 'Aceptamos transferencia bancaria, tarjeta de crédito y PayPal. El 50% se paga al inicio para comenzar el proyecto y el 50% restante al entregar tu página terminada.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-[#050510]" data-id="element-40">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="text-center mb-16" data-id="element-42">
          <h2 className="text-3xl md:text-5xl font-bold font-orbitron mb-4" data-id="element-43">
            Preguntas <span className="text-gradient-cosmic" data-id="element-44">Frecuentes</span>
          </h2>
          <p className="text-gray-400" data-id="element-45">
            Resolvemos tus dudas para que tomes la mejor decisión.
          </p>
        </div>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-xl bg-[#0a0a1a] overflow-hidden transition-all duration-300 hover:border-purple-500/30" data-id="element-47">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-48">
                <span className="text-lg font-medium text-white pr-8" data-id="element-49">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus className="w-5 h-5 text-purple-500 flex-shrink-0" data-id="element-50" /> : <Plus className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-51" />}
              </button>
              <AnimatePresence data-id="element-52">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-53">
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-54">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}